import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { AuthService, I18nModule } from '@spartacus/core';
import { AnonymousConsentManagementBannerModule, GenericLinkModule } from '@spartacus/storefront';

@Component({
  selector: 'app-gg-cookie-consent-message',
  templateUrl: './gg-cookie-consent-message.component.html',
  styleUrls: ['./gg-cookie-consent-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    AsyncPipe,
    I18nModule,
    GenericLinkModule,
    AnonymousConsentManagementBannerModule,
  ],
})
export class GgCookieConsentMessageComponent {
  videoStyleClass = input<string | undefined>();
  logged$ = inject(AuthService).isUserLoggedIn();
}
